import { genResponsivePx } from "@/stores/theme";
import { Button, Box, Flex, Image, Text, chakra, Tooltip } from "@chakra-ui/react";

export interface CardBoardCardProps {
  src: string;
  title: string;
  btnText: string;
  btnSelectedText: string;
  desc?: string;
  onClick?(): void;
  onBtnClick(): void;
  selected?: boolean;
}
function CardBoardCard(props: CardBoardCardProps) {
  const {
    src,
    title,
    btnText,
    onBtnClick,
    onClick = () => null,
    selected,
    btnSelectedText,
    desc,
    ...style
  } = props;
  return (
    <Box
      w={"230px"}
      h={"290"}
      p="4px"
      rounded="6px"
      bg="bg.panelBg"
      color="white"
      border="1px solid"
      borderColor={selected ? "brand.primary" : "text.primary"}
      onClick={onClick}
      {...style}
    >
      <Box rounded="4px" overflow="hidden" w="100%" h="auto">
        <Image src={src} crossOrigin="anonymous"></Image>
      </Box>
      <Flex justify="space-between" align="center" h="48px" px="12px">
        <Box cursor="default">
          <Text fontSize="14px" color="white" mb="6px">
            {title}
          </Text>
          <Tooltip label={desc} placement="bottom-start" hasArrow arrowSize={10} bg="text.primary">
            <Text
              color="text.secondary"
              fontSize="12px"
              maxW="130px"
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
            >
              {desc}
            </Text>
          </Tooltip>
        </Box>
        <Button
          variant="outline"
          color="text.secondary"
          borderColor="text.secondary"
          w={selected ? "64px" : "40px"}
          _hover={selected ? {} : undefined}
          _active={{}}
          cursor={selected ? "not-allowed" : "pointer"}
          h="20px"
          onClick={(e) => {
            e.stopPropagation();
            if (selected) return;
            onBtnClick();
          }}
        >
          {selected ? btnSelectedText : btnText}
        </Button>
      </Flex>
    </Box>
  );
}
export default chakra(CardBoardCard);
